import React from "react";

export default function StatCard({ label, value, testid }) {
  return (
    <div
      className="bg-white border border-[hsl(var(--kb-border))] p-6 rounded-sm"
      data-testid={testid}
    >
      <div className="overline mb-2">{label}</div>
      <div className="font-display text-3xl">{value}</div>
    </div>
  );
}
